// Fetch categories from the API
import instance from "../../utils/axios";

// export const getProduts = async (clientCode, categoryID, subCategoryID) => {
//   try {
//     if (!clientCode) {
//       throw new Error("Client code is required.");
//     }
//     if (!categoryID) {
//       throw new Error("Category ID is required.");
//     }
//     if (!subCategoryID) {
//       throw new Error("Sub Category ID is required.");
//     }
//     return await instance.get(
//       `/get-products/${encodeURIComponent(clientCode)}/${encodeURIComponent(
//         categoryID
//       )}/${encodeURIComponent(subCategoryID)}`
//     );
//   } catch (error) {
//     console.error("Error fetching categories:", error.message);
//     throw error; // Rethrow for further handling
//   }
// };

export const getProduts = async (clientCode, categoryID) => {
  try {
    if (!clientCode) {
      throw new Error("Client code is required.");
    }
    if (!categoryID) {
      throw new Error("Category ID is required.");
    }
    return await instance.get(
      `/get-products/${encodeURIComponent(clientCode)}/${encodeURIComponent(
        categoryID
      )}`
    );
  } catch (error) {
    console.error("Error fetching categories:", error.message);
    throw error; // Rethrow for further handling
  }
};

export const getProdutDetail = async (productID) => {
  try {
    if (!productID) {
      throw new Error("Product ID is required.");
    }
    return await instance.get(`/getproduct/${encodeURIComponent(productID)}`);
  } catch (error) {
    console.error("Error fetching categories:", error.message);
    throw error; // Rethrow for further handling
  }
};
